/**
 * DEFAULT for 3/4 front image
 * PROFILE for side-view image
 */
export enum ImageType {
  DEFAULT = 'DEFAULT',
  PROFILE = 'PROFILE',
}
